import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CustomerFacade } from './+state';
import { CustomerActions } from './+state/customer.actions';
import { CustomerEpics } from './+state/customer.epic';
import { CustomerService } from './customer.service';
import { CustomerRequestAllowedGuard } from './guards/customer-request-allowed.guard';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [CustomerService, CustomerActions, CustomerFacade, CustomerEpics, CustomerRequestAllowedGuard]
})
export class CustomerModule {}
